import React from 'react';
//material
import {
  Container,
  Grid,
  withStyles,
} from '@material-ui/core';
//styles
import styles from './show-member-styles'
//components
import MemberCard from '../../../components/member/member-card';
import ContactDetailsCard from '../../../components/member/contact-details-card';
import MeetingsCard from '../../../components/member/meetings-card';
import EventsCard from '../../../components/member/events-card';
//utils
import {getBooleanSettingValue, keys} from '../../../utils/settings';

const ShowMemberView = (props) => {
  const {classes, member, isLoading, events, pastEvents, meetings, pastMeetings} = props;

  return(
    <div>
      <div style={{backgroundImage: `url(${!isLoading ? member.bannerImageUrl : ''})`}} className={classes.heroImage}/>

      <Container maxWidth={'md'} className={classes.container}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MemberCard
              isLoading={isLoading}
              member={member}
              updateDescription={props.updateMemberDescription} />
          </Grid>

          <Grid item xs={12}>
            <ContactDetailsCard
              isLoading={isLoading}
              member={member} />
          </Grid>

          {
            getBooleanSettingValue(keys.showGroups) &&
            <Grid item xs={12}>
              <MeetingsCard
                meetings={meetings}
                pastMeetings={pastMeetings}
                isLoading={isLoading} />
            </Grid>
          }

          <Grid item xs={12}>
            <EventsCard
              events={events}
              pastEvents={pastEvents}
              isLoading={isLoading} />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default withStyles(styles) (ShowMemberView);
